"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["basket"] = "basket";
  TranslationKey["billingAddress"] = "billingAddress";
  TranslationKey["cardConsentIsRequired"] = "cardConsentIsRequired";
  TranslationKey["checkout"] = "checkout";
  TranslationKey["continueClickIsRequired"] = "continueClickIsRequired";
  TranslationKey["deliveryChannelIsMissing"] = "deliveryChannelIsMissing";
  TranslationKey["edit"] = "edit";
  TranslationKey["goToYourProfileSettings"] = "goToYourProfileSettings";
  TranslationKey["items"] = "items";
  TranslationKey["loading"] = "loading";
  TranslationKey["mandatoryBillingAddressMissing"] = "mandatoryBillingAddressMissing";
  TranslationKey["mandatoryEmailMissing"] = "mandatoryEmailMissing";
  TranslationKey["mandatoryPhoneMissing"] = "mandatoryPhoneMissing";
  TranslationKey["myInformation"] = "myInformation";
  TranslationKey["needToMakeAChange"] = "needToMakeAChange";
  TranslationKey["noBasketItemsFound"] = "noBasketItemsFound";
  TranslationKey["offers"] = "offers";
  TranslationKey["orderIsPlacedAlready"] = "orderIsPlacedAlready";
  TranslationKey["payment"] = "payment";
  TranslationKey["recurringPaymentConsentIsRequired"] = "recurringPaymentConsentIsRequired";
  TranslationKey["yourEmailAddressIsMissing"] = "yourEmailAddressIsMissing";
  TranslationKey["yourPhoneNumberIsMissing"] = "yourPhoneNumberIsMissing";
  return TranslationKey;
}({});